// utils/hashing.js

export const hashing = 'dF5NQqK4lBpncFdVNBwzEnJz8hWgEUEH';
export const base = 'https://gateway.cloudrestfulapi.com/api/';
